import { h, Component } from 'preact';
import util from 'preact-util';
import { observer } from 'mobx-preact';
import { Text, Localizer, withText } from 'preact-i18n';
import { route } from 'preact-router';
import Markdown from 'preact-markdown';

import localUtil from '../../lib/util';
import fields from '../../lib/fields';

import ViewFields from '../../components/form/viewFields';
import Input from '../../components/form/input';
import DyrejournalSaleSearch from '../../components/dyrejournal/search';
import DyrejournalSalePrescription from '../../components/dyrejournal/salePrescription';
import { animalAge } from '../../lib/animalAge';

const fieldSorter = (fields) => (a, b) => fields.map(o => {
    let dir = 1;
    if (o[0] === '-') {
        dir = -1;
        o = o.substring(1);
    }
    return a[o] > b[o] ? dir : a[o] < b[o] ? -(dir) : 0;
}).reduce((p, n) => p ? p : n, 0);

@observer
class VisitorJournalListMini extends Component {
	constructor(props) {
        super(props);
        this.state = {
            selectedJournals: [],
        };
    }

    loadAll = async (props = this.props, emptyFirst = true) => {
        const { visitors = [] } = props;
        if (!visitors || visitors.length === 0) {
            this.setState({ visitorJournals: [] });
            return;
        }
        if (emptyFirst) {
            this.setState({ visitorJournals: [] });
        }
        const { journalStore } = this.props.stores;
        const response = await journalStore.load({
            query: {
                visitor: visitors.map(v => v.id),
            },
            skipUpdate: true,
            addData: ['animals', 'visitors', 'veterinaries', 'totalJournals'],
        });
        journalStore.updateKeyValue('visitorJournals', response);
        await journalStore.loadVeterinaries();
    }

    onClickEditJournal = e => {
        e.stopPropagation();
        e.preventDefault();
        const { id, animal } = e.target.closest('.journalLine').dataset;
        const idInt = parseInt(id, 10);
        const animalInt = parseInt(animal, 10);

        const {
            drawerLevel = 1,
            saveSale = () => {},
            saleIsLocked = false,
        } = this.props;
		const { appState, saleStore, journalStore } = this.props.stores;
        const { newSale } = saleStore;
        const { animals } = newSale;

		appState.openDrawerRight('editJournal', {
            isNew: false,
            hideAdmin: true,
            saveSale,
            saleIsLocked,
            id: idInt,
            animals: animals.filter(a => a.id === animalInt),
            callback: async () => {
                // console.log('onClickEditJournal callback');
                const { newJournal } = journalStore;
                const { newSale } = saleStore;
                const { journals } = newSale;
                const idx = journals.findIndex(a => a.id === newJournal.id);
                if (idx > -1) {
                    saleStore.updateObjectKeyArrValue('newSale', 'journals', idx, newJournal);
                    await saveSale({ calledFrom: 'listJournalMini.onClickEditJournal.callback', fieldsToSave: ['journals'] });
                } else {
                    saleStore.updateObjectKeyValue('newSale', 'journals', [...journals, newJournal]);
                    await saveSale({ calledFrom: 'listJournalMini.onClickEditJournal.callback', fieldsToSave: ['journals'] });
                }
            },
		}, drawerLevel + 1);
    }

    onClickViewJournal = e => {
        e.stopPropagation();
        e.preventDefault();
        const { id } = e.target.closest('.journalLine').dataset;
        const { drawerLevel = 1 } = this.props;
        const { appState } = this.props.stores;
        const { drawerHeightLarge } = appState;

        appState.openDrawer('viewJournal', {
            hideAdmin: true,
            height: drawerHeightLarge,
            id: parseInt(id, 10),
        }, drawerLevel + 1);
    }

    sendJournals = async e => {
        e.stopPropagation();
        e.preventDefault();
        const { selectedJournals } = this.state;
        const { drawerLevel = 1 } = this.props;
        const { appState, journalStore } = this.props.stores;
        const { drawerHeightLarge } = appState;
        const { visitorJournals = [] } = journalStore;
        const journalsToSend = visitorJournals.filter(j => selectedJournals.indexOf(j.id) > -1);

        if (journalsToSend.length === 0) return;

        appState.openDrawer('sendJournal', {
            hideAdmin: true,
            height: drawerHeightLarge,
            journals: journalsToSend,
        }, drawerLevel + 2);
    }

    toggleSelectAll = e => {
        e.stopPropagation();
        const { journalStore } = this.props.stores;
        const { visitorJournals = [] } = journalStore;
        const { selectedJournals = [] } = this.state;
        const allIds = visitorJournals.map(j => j.id);
        const allSelected = allIds.length > 0 && allIds.every(id => selectedJournals.includes(id));
        this.setState({
            selectedJournals: allSelected ? [] : allIds,
        });
    }

    toggleSelectJournal = (id, e) => {
        e.stopPropagation();
        const idInt = parseInt(id, 10);
        const { selectedJournals = [] } = this.state;
        const idx = selectedJournals.indexOf(idInt);
        const next = [...selectedJournals];
        if (idx > -1) {
            next.splice(idx, 1);
        } else {
            next.push(idInt);
        }
        this.setState({ selectedJournals: next });
    }

    // onClickPrintPrescriptoin = e => {
    //     // console.log('onClickPrintPrescriptoin', e);
    //     // Render Prescription component with data
    //     const prescription = <DyrejournalSalePrescription stores={this.props.stores} />;
    //     // Append to document
    //     const printDiv = document.createElement('div');
    //     printDiv.className = 'prescription';
    //     document.body.appendChild(printDiv);
    //     render(prescription, printDiv);
    //     // Trigger print dialog
    //     window.print();
    //     // Remove the appended div
    //     document.body.removeChild(printDiv);
    // // Re-render the receipt component to reset it
    // render(null, printDiv);
    // }

    toggleHeight = e => {
        e.stopPropagation();
        e.preventDefault();
        const { height = 150 } = this.state;
        this.setState({ height: height === 150 ? 500 : 150 });
    }

    componentDidMount() {
        const { collapse = false } = this.props;
        this.setState({
            collapsed: collapse,
            selectedJournals: [],
        });
        this.loadAll();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.visitors !== this.props.visitors) {
            this.loadAll(nextProps)
        }
    }

    renderDiagnoses(journal) {
        const diagnoses = (journal.diagnoses || []).filter(d => d && (d.name || d.diagnoseCode));
        if (diagnoses.length === 0) {
            return null;
        }
        return diagnoses.map(d => (
            <span class='d-block' key={d.uuidv4 || `${d.diagnoseCode}-${d.name}`}>
                {d.name}
                {d.diagnoseCode && <small class='text-body-secondary ms-1'>({d.diagnoseCode})</small>}
            </span>
        ));
    }

    render() {
        const { height = 150 } = this.state;

        const {
            viewOnly = false,
            noSendTo = false,
        } = this.props;
        const { selectedJournals = [], collapsed = false } = this.state;
        const { userStore, animalStore, journalStore } = this.props.stores;
        const { user, isAdmin } = userStore;
        const { owners } = animalStore;
        const { visitorJournals = [], animals = [] } = journalStore;
        const darkmode= util.getNestedValue(user, 'settings.darkmode');

        const allIds = visitorJournals.map(j => j.id);
        const allSelected = allIds.length > 0 && allIds.every(id => selectedJournals.includes(id));

        return (<>
            {visitorJournals && visitorJournals.length > 0 && <>

                <div class={`${darkmode ? 'bg-darkmode' : 'bg-lightmode'} w-100 mx-1 d-flex flex-column py-0 px-1`}>

                    <small>
                        <div class='d-flex overflow-hidden w-100 font-style-narrow' style={`max-height: ${height}px;`}>
                            <div class='table-responsive'>
                                <table class='table table-striped table-sm mb-0'>
                                    <thead class=''>
                                        <tr>
                                            {!noSendTo && (
                                                <th scope='col' class='text-center' style='width: 32px;'>
                                                    <input
                                                        type='checkbox'
                                                        class='form-check-input'
                                                        checked={allSelected}
                                                        onClick={e => e.stopPropagation()}
                                                        onChange={this.toggleSelectAll}
                                                    />
                                                </th>
                                            )}
                                            <th scope='col'><Text id='animal.journal-date'>Journal date</Text></th>
                                            <th scope='col'><Text id='animal.journal-animal'>Animal</Text></th>
                                            <th scope='col' class='text-center'><Text id='animal.journal-prescription'>Prescriptions</Text></th>
                                            <th scope='col'><Text id='animal.journal-chiefComplaint'>chiefComplaint</Text></th>
                                            <th scope='col'><Text id='animal.journal-treatmentPlan'>treatmentPlan</Text></th>
                                            <th scope='col'><Text id='animal.journal-diagnoses'>Diagnoses</Text></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {visitorJournals.sort(fieldSorter(['-date'])).map(j => {
                                            const diff = util.dateDiff(j.date);
                                            const lineSaleIsLocked = j.closed;
                                            const isSelected = selectedJournals.indexOf(j.id) > -1;
                                            return (<>
                                                <tr
                                                    class='journalLine'
                                                    onClick={(lineSaleIsLocked || viewOnly) ? this.onClickViewJournal : this.onClickEditJournal}
                                                    data-id={j.id}
                                                    data-animal={j.animal}
                                                >
                                                    {!noSendTo && (
                                                        <td class={`text-center ${isSelected ? 'bg-success-subtle' : ''}`}>
                                                            <input
                                                                type='checkbox'
                                                                class='form-check-input'
                                                                checked={isSelected}
                                                                onClick={e => e.stopPropagation()}
                                                                onChange={e => this.toggleSelectJournal(j.id, e)}
                                                            />
                                                        </td>
                                                    )}
                                                    <td class={isSelected ? 'bg-success-subtle' : ''}>
                                                        {util.formatDate(j.date, { hour12: false, hour: '2-digit', minute: '2-digit', locale: 'nb-NO' })}
                                                    </td>
                                                    <td class={`text-start ${isSelected ? 'bg-success-subtle' : ''}`}>
                                                        {j.animalName && <span class='ms-1'>{j.animalName}</span>}
                                                        {j.animalSpecies && <span class='ms-1'>({j.animalSpecies})</span>} {j.animalBreed && <span class='ms-1'>({j.animalBreed})</span>}
                                                        {j.animalBirth && <span class='ms-1'>({animalAge(j.animalBirth)})</span>}
                                                    </td>
                                                    <td class={`text-center ${isSelected ? 'bg-success-subtle' : ''}`}>
                                                        {j.prescriptions && j.prescriptions.length > 0 && <>
                                                            {j.prescriptions.length}
                                                        </>}
                                                    </td>
                                                    <td class={isSelected ? 'bg-success-subtle' : ''}>
                                                        {j.chiefComplaint && <>
                                                            <Markdown markdown={j.chiefComplaint || ''} markedOpts={localUtil.getMarkdownOptions()} />
                                                        </>}
                                                    </td>
                                                    <td class={isSelected ? 'bg-success-subtle' : ''}>{j.treatmentPlan}</td>
                                                    <td class={isSelected ? 'bg-success-subtle' : ''}>{this.renderDiagnoses(j)}</td>
                                                </tr>
                                            </>)
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div class='d-flex flex-row justify-content-center align-items-center mt-0'>
                            <button class='btn btn-sm btn-link rounded-pill mt-1' onClick={this.toggleHeight}>
                                {height === 150 ? <>
                                    <i class='fa-duotone fa-chevron-down me-2' />
                                    <Text id='input.show-more'>Show more</Text>
                                </> : <>
                                    <i class='fa-duotone fa-chevron-up me-2' />
                                    <Text id='input.show-less'>Show less</Text>
                                </>}
                            </button>
                        </div>

                        {!noSendTo && selectedJournals.length > 0 && (
                            <div class='d-flex flex-row justify-content-center my-2'>
                                <button type='button' class='btn btn-sm btn-primary rounded-pill' onClick={this.sendJournals}>
                                    <i class='fas fa-paper-plane me-1' />
                                    <Text id='dyrejournal.send-selected-journals' fields={{ count: selectedJournals.length }}>
                                        Send {selectedJournals.length} selected journals
                                    </Text>
                                </button>
                            </div>
                        )}

                    </small>

                </div>
            </>}
        </>);
    }
}

export default VisitorJournalListMini;
